import React from 'react';

import AutoresizeTextarea from 'components/ui-components/autoresize-textarea';

import styles from './styles.module.less';
import AutoresizeMentionTextarea from '../../ui-components/autoresize-mention-textarea';

import { useFlagIsActivated } from 'hooks/featureFlag';
import {
  ROLLOUT_AT_MENTION_COMMENT,
  ROLLOUT_EXTERNAL_AT_MENTION,
} from 'constants/featureFlag';
import { searchWorkspaceMembersFn } from 'utilities/comments';
import { useGetSelectedWorkspace } from 'hooks/workspace';

const MAX_ROWS = 4;
const MIN_ROWS = 2;

const CommentTextArea = ({
  comment,
  placeholder,
  onChange,
  onKeyDown,
  autofocus,
  inputSize,
}: {
  comment: string;
  placeholder: string;
  onChange: (arg0: string) => void;
  onKeyDown?: (arg0: Event) => void;
  autofocus: boolean;
  inputSize: string;
}): JSX.Element => {
  const isMentionComponentEnabled = useFlagIsActivated({
    flag: ROLLOUT_AT_MENTION_COMMENT,
    activationValues: [true],
  });
  const isExternalMentionEnabled = useFlagIsActivated({
    flag: ROLLOUT_EXTERNAL_AT_MENTION,
    activationValues: [true],
  });

  const handleChangeEvent = ev => onChange(ev?.target?.value);

  const selectedWorkspace = useGetSelectedWorkspace();
  const fetchFn = searchWorkspaceMembersFn(
    selectedWorkspace.id,
    Boolean(isExternalMentionEnabled)
  );

  const ref = React.useRef<HTMLTextAreaElement>(null);

  React.useEffect(() => {
    if (!ref.current || !autofocus) {
      return;
    }

    ref.current.focus({ preventScroll: true });
  }, [autofocus, ref]);

  return (
    <>
      {isMentionComponentEnabled ? (
        <AutoresizeMentionTextarea
          textRef={ref}
          data-testid="comment-entry-field"
          size={inputSize}
          value={comment}
          placeholder={'Leave a comment or mention someone with @mention'}
          onChange={handleChangeEvent}
          minRows={MIN_ROWS}
          maxRows={MAX_ROWS}
          fetch={fetchFn}
          onKeyDown={onKeyDown}
          hasError={false}
        />
      ) : (
        <AutoresizeTextarea
          autoFocus={autofocus}
          data-testid="comment-entry-field"
          size={inputSize}
          className={styles.textArea}
          value={comment}
          placeholder={placeholder}
          onChange={handleChangeEvent}
          minRows={MIN_ROWS}
          maxRows={MAX_ROWS}
          onKeyDown={onKeyDown}
        />
      )}
    </>
  );
};

export default CommentTextArea;
